import store from '@/store'
export default {
  bind (el, binding) {
    if (binding.value === '_default') {
      return
    }
    if (store.state.privileges && store.state.privileges.length) {
      if (store.state.privileges.indexOf(binding.value) === -1) {
        el.remove()
      }
    }
  },
  inserted (el, binding) {
    if (binding.value === '_default') {
      return
    }
    if (store.state.privileges && store.state.privileges.length) {
      if (store.state.privileges.indexOf(binding.value) === -1) {
        el.remove()
      }
    }
  },
  update (el, binding) {
    if (binding.value === '_default') {
      return
    }
    if (store.state.privileges && store.state.privileges.length) {
      if (store.state.privileges.indexOf(binding.value) === -1) {
        el.remove()
      }
    }
  }
}
